import { render, staticRenderFns } from "./UrunSecilenKurItem.vue?vue&type=template&id=273c3ba9&scoped=true"
import script from "./UrunSecilenKurItem.vue?vue&type=script&lang=js"
export * from "./UrunSecilenKurItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c3ba9",
  null
  
)

export default component.exports